module.exports = __webpack_public_path__ + "8dd919f5433f0548adf44adc82d96384.svg";